import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {injectIntl} from "@irati/utils/lang"
import getMessage from "@irati/utils/lang/helpers/getMessage"
import id from "@irati/utils/id"
import padding from "@irati/ui/src/global/padding"

import {Menu} from "../../ui/Menu"
import sitemap from "../../routes/sitemap"

const StyledMenu = styled(Menu)`
  margin-left: ${padding.tiny};
`

class DropDown extends PureComponent {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired
  }

  getActionList = () => [
    {
      label: getMessage(this, "insights.homepage.actions.reports.cta"),
      action: sitemap.reports.url,
      icon: "report"
    }
  ]

  render() {
    const idNamespace = id("DropDown", this.props)

    return (
      <StyledMenu
        id={idNamespace}
        pullRight
        slim
        items={this.getActionList()} />
    )
  }
}

export default injectIntl(DropDown)
